import qs from 'qs';
import React from 'react';
import md5 from 'blueimp-md5';
import dayjs from 'dayjs';
import _ from 'lodash';
import { orderStatus } from '@/models/orders/defines/constants';
import { isImmutable } from 'immutable';

const tenantMode = process.env.APP_MODE === 'tenant';
const isManagerMode = process.env.APP_MODE === 'manager';

function getDisplayName(component) {
  return component.displayName || component.name || 'Component';
}

export function withQuery(component) {
  return class WithQuery extends React.Component {
    static displayName = `withQuery(${getDisplayName(component)})`;

    render() {
      const { location } = this.props;
      const query = qs.parse(location.search.slice(1));

      return React.createElement(component, {
        ...this.props,
        query,
      });
    }
  };
}

export const orderStatusMappings = {
  [orderStatus.WAIT_RECIEW]: {
    text: '待接收',
    backgroundColor: '#63AC14',
    color: '#FFFFFF',
    borderColor: '',
  },
  [orderStatus.WAIT_PRICING]: {
    text: '待定价',
    backgroundColor: '#F5A623',
    color: '#FFFFFF',
    borderColor: '',
  },
  [orderStatus.WAIT_LOCK_FEE]: {
    text: '定价中',
    backgroundColor: '#417505',
    color: '#FFFFFF',
    borderColor: '',
  },
  [orderStatus.LOCK_FEE_FAILD]: {
    text: '定金锁定失败',
    backgroundColor: '#D0021B',
    color: '#FFFFFF',
    borderColor: '',
  },
  [orderStatus.WAIT_ASSIGN]: {
    text: '待指派',
    backgroundColor: '#9c27b0',
    color: '#FFFFFF',
    borderColor: '',
  },
  [orderStatus.PROCESSING_WAIT_APPOINTMENT]: {
    text: '待预约',
    backgroundColor: '#FF731B',
    color: '#FFFFFF',
    borderColor: '',
  },
  [orderStatus.PROCESSING_WAIT_SERVICE]: {
    text: '待上门',
    backgroundColor: '#FAA819',
    color: '#FFFFFF',
    borderColor: '',
  },
  [orderStatus.WORKER_LOCATION_CHECKED]: {
    text: '正在上门',
    backgroundColor: '#17A55C',
    color: '#FFFFFF',
    borderColor: '',
  },
  [orderStatus.ORDER_INSPECTION]: {
    text: '正在上门',
    backgroundColor: '#17A55C',
    color: '#FFFFFF',
    borderColor: '',
  },
  [orderStatus.PROCESSING_COMPLETED]: {
    // text: '待客服确认',
    text: '待确认',
    backgroundColor: '#4E85F1',
    color: '#FFFFFF',
    borderColor: '',
  },
  [orderStatus.PROCESSING_WAIT_TENANT_RECEIPT]: {
    text: '待商户确认',
    backgroundColor: '#4E85F1',
    color: '#FFFFFF',
    borderColor: '',
  },
  [orderStatus.DONE]: {
    text: '待结算',
    backgroundColor: '#747A6E',
    color: '#FFFFFF',
    borderColor: '',
  },
  [orderStatus.DONE_CLOSE]: {
    text: '已结算',
    backgroundColor: '#666666',
    color: '#FFFFFF',
    borderColor: '',
  },
  [orderStatus.CANCEL]: {
    text: '已取消',
    backgroundColor: '#CCCCCC',
    color: '#818181',
    borderColor: '',
  },

  [orderStatus.TENANT_APPEAL]: {
    text: '商家申诉',
    backgroundColor: '#d5d5d5',
    color: '#818181',
    borderColor: '',
  },

  [orderStatus.TENANT_CLOSE]: {
    text: '商家取消',
    backgroundColor: '#d5d5d5',
    color: '#818181',
    borderColor: '',
  },

  [orderStatus.TENANT_CLOSE_FIALED]: {
    text: '拒绝取消',
    backgroundColor: '#d5d5d5',
    color: '#818181',
    borderColor: '',
  },
  [orderStatus.GUAQI]: {
    text: '挂起工单',
    backgroundColor: '#CCCCCC',
    color: '#818181',
    borderColor: '',
  },
  [orderStatus.WORKER_GUAQI]: {
    text: '师傅挂起工单',
    backgroundColor: '#CCCCCC',
    color: '#818181',
    borderColor: '',
  },
  [orderStatus.MANAGER_IGNORE]: {
    text: '忽略工单',
    backgroundColor: '#CCCCCC',
    color: '#818181',
    borderColor: '',
  },
  [orderStatus.MANAGER_CLOSE]: {
    text: '结束会话',
    backgroundColor: '#CCCCCC',
    color: '#818181',
    borderColor: '',
  },
  [orderStatus.TENANT_EVALUATE]: {
    text: '商家评价',
    backgroundColor: '#CCCCCC',
    color: '#818181',
    borderColor: '',
  },
  [orderStatus.TENANT_CLAIM]: {
    text: '商家索赔',
    backgroundColor: '#CCCCCC',
    color: '#818181',
    borderColor: '',
  },
  [orderStatus.MANAGER_CLAIM]: {
    text: '客服审批索赔',
    backgroundColor: '#CCCCCC',
    color: '#818181',
    borderColor: '',
  },
  [orderStatus.EVALUATE_APPEAL]: {
    text: '师傅评价申诉',
    backgroundColor: '#CCCCCC',
    color: '#818181',
    borderColor: '',
  },
  [orderStatus.REMIND_ORDER]: {
    text: '商家催单',
    backgroundColor: '#CCCCCC',
    color: '#818181',
    borderColor: '',
  },
  [orderStatus.TENANT_CONFIRM_FEE]: {
    text: '商家同意报价',
    backgroundColor: '#CCCCCC',
    color: '#818181',
    borderColor: '',
  },
  [orderStatus.TENANT_REFUSE_FEE]: {
    text: '商家拒绝报价',
    backgroundColor: '#CCCCCC',
    color: '#818181',
    borderColor: '',
  },
  [orderStatus.WORKER_QUOTATION]: {
    text: '师傅报价',
    backgroundColor: '#CCCCCC',
    color: '#818181',
    borderColor: '',
  },
};
export const orderEventMappings = {
  [orderStatus.WAIT_RECIEW]: {
    eventName: '下单',
  },
  [orderStatus.WAIT_PRICING]: {
    eventName: '工单接收'
  },
  [orderStatus.WAIT_LOCK_FEE]: {
    eventName: '定价'
  },
  [orderStatus.WAIT_ASSIGN]: {
    eventName: '价格锁定'
  },
  [orderStatus.CHANGE_FEE]: {
    eventName: '调整价格'
  },
  [orderStatus.PROCESSING_WAIT_APPOINTMENT]: {
    eventName: '已指派师傅'
  },
  [orderStatus.PROCESSING_WAIT_SERVICE]: {
    eventName: '预约完成'
  },
  [orderStatus.WORKER_LOCATION_CHECKED]: {
    eventName: '师傅签到'
  },
  [orderStatus.ORDER_INSPECTION]: {
    eventName: '验货'
  },
  [orderStatus.PROCESSING_COMPLETED]: {
    eventName: '师傅交单'
  },
  [orderStatus.PROCESSING_WAIT_TENANT_RECEIPT]: {
    eventName: '客服确认'
  },
  [orderStatus.DONE]: {
    eventName: '工单完成'
  },
  [orderStatus.DONE_CLOSE]: {
    eventName: '已结算'
  },
  [orderStatus.CANCEL]: {
    eventName: '已取消'
  },
  [orderStatus.TENANT_APPEAL]: {
    eventName: '商家申诉',
  },
  [orderStatus.MANAGER_APPEAL_FOR_WORKER]: {
    eventName: '客服申诉给师傅调价',
  },
  [orderStatus.MANAGER_APPEAL_FOR_TENANT]: {
    eventName: '客服申诉给商家调价',
  },
  [orderStatus.TENANT_APPEAL_SUCCEED]: {
    eventName: '商家申诉成功',
  },
  [orderStatus.TENANT_APPEAL_FIALED]: {
    eventName: '商家申诉失败',
  },
  [orderStatus.MANAGER_APPEAL_FOR_WORKER_SUCCEED]: {
    eventName: '客服申诉给师傅调价成功',
  },
  [orderStatus.TMANAGER_APPEAL_FOR_WORKER_FIALED]: {
    eventName: '客服申诉给师傅调价失败',
  },
  [orderStatus.MANAGER_APPEAL_FOR_TENANT_SUCCEED]: {
    eventName: '客服申诉给商家调价成功',
  },
  [orderStatus.MANAGER_APPEAL_FOR_TENANT_FIALED]: {
    eventName: '客服申诉给商家调价失败',
  },
  [orderStatus.TENANT_CLOSE]: {
    eventName: '商家申诉取消订单',
  },
  [orderStatus.TENANT_CLOSE_FIALED]: {
    eventName: '客服拒绝取消订单',
  },
  [orderStatus.GUAQI]: {
    eventName: '挂起工单',
  },
  [orderStatus.WORKER_GUAQI]: {
    eventName: '师傅挂起工单',
  },
  [orderStatus.MANAGER_IGNORE]: {
    eventName: '忽略工单',
  },
  [orderStatus.MANAGER_CLOSE]: {
    eventName: '结束会话',
  },
  [orderStatus.TENANT_EVALUATE]: {
    eventName: '商家评价',
  },
  [orderStatus.TENANT_CLAIM]: {
    eventName: '商家索赔',
  },
  [orderStatus.MANAGER_CLAIM]: {
    eventName: '客服审批索赔',
  },
  [orderStatus.EVALUATE_APPEAL]: {
    eventName: '师傅评价申诉',
  },
  [orderStatus.REMIND_ORDER]: {
    eventName: '商家催单',
  },
  [orderStatus.TENANT_CONFIRM_FEE]: {
    eventName: '商家同意报价',
  },
  [orderStatus.TENANT_REFUSE_FEE]: {
    eventName: '商家拒绝报价',
  },
  [orderStatus.WORKER_QUOTATION]: {
    eventName: '师傅报价',
  },
  [orderStatus.ORDER_WAIT_QUOTATION]: {
    eventName: '工单待报价',
  },
  [orderStatus.ORDER_WAIT_PAYID]: {
    eventName: '工单待支付',
  },
  [orderStatus.ORDER_WAIT_EVALUATE]: {
    eventName: '工单待评价',
  },
  [orderStatus.MANAGER_CLAIM_AGREE]: {
    eventName: '客服同意索赔',
  },
  [orderStatus.MANAGER_CLAIM_REFRUSE]: {
    eventName: '客服拒绝索赔',
  },
  [orderStatus.CODE_PROCESSING_COMPLETED]: {
    eventName: '验证码交单',
  },
  [orderStatus.NO_CODE_PROCESSING_COMPLETED]: {
    eventName: '无验证码交单',
  },
  [orderStatus.REMIND_QUOTATION]: {
    eventName: '散户催报价',
  },
  [orderStatus.MODIFY_ORDER]: {
    eventName: '修改工单',
  },
  [orderStatus.ACCEPT_FAILED_FREE_ON_SITE]: {
    eventName: '验收不通过-免费上门',
  },
  [orderStatus.CHECK_ACCEPT_FAILED_ON_SITE]: {
    eventName: '师傅审批散户免费上门申请',
  },
  [orderStatus.DOWN_APPLY_FEE]: {
    eventName: '散户申请下调费用',
  },
  [orderStatus.CHECK_DOWN_APPLY_FEE_AGREE]: {
    eventName: '师傅同意散户申请下调费用',
  },
  [orderStatus.WORKER_APPLY_FEE]: {
    eventName: '师傅申请新增费用',
  },
  [orderStatus.CHECK_WORKER_APPLY_FEE_AGREE]: {
    eventName: '同意并支付师傅申请费用',
  },
  [orderStatus.WORKER_APPLY_ARBITRATION]: {
    eventName: '师傅申请仲裁',
  },
  [orderStatus.RETAIL_APPLY_ARBITRATION]: {
    eventName: '散户申请仲裁',
  },
  [orderStatus.RETAIL_APPLY_ARBITRATION_APPEAL]: {
    eventName: '散户申请仲裁申诉',
  },
  [orderStatus.WORKER_APPLY_ARBITRATION_APPEAL]: {
    eventName: '师傅申请仲裁申诉',
  },
  [orderStatus.MANAGER_ARBITRATION_APPEAL_AGREE]: {
    eventName: '客服同意仲裁',
  },
  [orderStatus.MANAGER_ARBITRATION_APPEAL_REFRUSE]: {
    eventName: '客服拒绝仲裁',
  },
  [orderStatus.WORKER_ORDERINSPECT_NORMAL]: {
    eventName: '师傅验货正常',
  },
  [orderStatus.WORKER_ORDERINSPECT_ABNORMAL]: {
    eventName: '师傅验货异常',
  },
  [orderStatus.RETAIL_CHOICE_WORKER_PAY]: {
    eventName: '散户指派师傅并付款',
  },
  [orderStatus.RETAIL_UP_APPLY_FEE]: {
    eventName: '散户申请新增费用并支付',
  },
  [orderStatus.RETAIL_APPLY_BACK]: {
    eventName: '散户申请退款',
  },
  [orderStatus.WORKER_APPLY_BACK_AGREE]: {
    eventName: '师傅同意退款',
  },
  [orderStatus.WORKER_APPLY_BACK_REFUSE]: {
    eventName: '师傅拒绝退款',
  },
  [orderStatus.WORKER_SIGN_CAPTCHA]: {
    eventName: '师傅输入验证码完单',
  },
  [orderStatus.RETAIL_APPLY_WARRANTY]: {
    eventName: '散户申请质保',
  },
  [orderStatus.WORKER_WARRANTY_AGREE]: {
    eventName: '师傅同意并预约时间',
  },
  [orderStatus.CHECK_DOWN_APPLY_FEE_REFUSE]: {
    eventName: '拒绝散户申请下调费用',
  },
  [orderStatus.CHECK_WORKER_APPLY_FEE_REFUSE]: {
    eventName: '拒绝师傅申请费用',
  },
  [orderStatus.RETAIL_CONFIRM_PAY]: {
    eventName: '散户支付并验收',
  },
  [orderStatus.RETAIL_REFUSE_WARRANTY]: {
    eventName: '散户拒绝质保',
  },
  [orderStatus.RETAIL_CONFIRM_ORDER]: {
    eventName: '散户确认验收',
  },
  [orderStatus.RETAIL_AUTO_CONFIRM_ORDER]: {
    eventName: '自动确认验收',
  },
  [orderStatus.MANAGER_CONFIRM_ORDER]: {
    eventName: '客服确认验收',
  },
  [orderStatus.TENANT_CONFIRM_ORDER]: {
    eventName: '商家确认验收',
  },
  [orderStatus.WORKER_ARBITRATIONAGAIN]: {
    eventName: '师傅补充仲裁材料',
  },
  [orderStatus.RETAIL_ARBITRATIONAGAIN]: {
    eventName: '散户补充仲裁材料',
  },
}
export function getEventByCode(code) {
  if (!code) {
    return null;
  }
  const status = orderEventMappings[code];
  if (!status) {
    return null;
  }
  return status.eventName;
}
export function getStatusByCode(code) {
  const status = orderStatusMappings[code];
  if (!status) {
    return {};
  }

  const { text, ...style } = status;
  return {
    text,
    style,
  };
}

export function getStatus(order) {
  if (isImmutable(order)) {
    order = order.toJS();
  }
  const status = orderStatusMappings[order?.status_code];
  if (!status) {
    return {};
  }
  if (tenantMode) {
    if (order.status_code == orderStatus.WAIT_LOCK_FEE) {
      return {};
    }
  }

  let { text, ...style } = status;
  // if (order.status_code == orderStatus.WAIT_ASSIGN && order.ticket_type == 2) {
  //   if (process.env.APP_MODE === 'tenant') {
  //     text = '待指派'
  //   } else if (process.env.APP_MODE === 'manager') {
  //     text = '指派师傅'
  //     style.backgroundColor = '#ca4141'
  //   }
  // }
  return {
    text,
    style,
  };
}

/**
 * 获取标签对应的文字
 * @param {*} tag
 */
export function getTag(tag) {
  const tagObj = {
    TAG_SERVICE_FAILD: {
      text: '上门失败',
      backgroundColor: '#f55e22',
      color: '#FFFFFF',
      borderColor: '',
    },
    TAG_WAIT_EXPRESS: {
      text: '待返件',
      backgroundColor: '#B8B8B8',
      color: '#333',
      borderColor: '',
    },
    TAG_WAIT_SEND_EXPRESS: {
      text: '待发件',
      backgroundColor: '#B8B8B8',
      color: '#333',
      borderColor: '',
    },
  };
  const defaultTag = {
    text: tag,
    backgroundColor: '#000',
    color: '#FFFFFF',
    borderColor: '',
  };

  // console.log('tag:', tag, tagObj[tag])

  return tagObj[tag] || defaultTag;
}

export function formatSystemMessage(msg) {
  if (msg.get('from_type') !== 'system') {
    return '未知类型消息';
  }
  const msg_type = msg.get('message_type');
  const msg_text = msg.get('text');
  const systemMessages = {
    order_created: '工单已创建',
    cs_connected: `客服 ”<span>${msg.getIn(['params', 'staff_no']) || msg.getIn(['params', 'username'])
      }</span>” 已接入`,
    staff_connected: `客服 “<span>${msg.getIn(['params', 'staff_no']) || msg.getIn(['params', 'username'])
      }</span>” 已接入`, // 历史遗留问题 ...
    tenant_staff_changed: `企业员工 ”<span>${msg.getIn(['params', 'staff_no']) || msg.getIn(['params', 'username'])
      }</span>” 已接手处理当前订单`,
    fee_changed: '客服已调整工费',
    service_time_changed:
      (msg.getIn(['params', 'operatorType']) === 'worker' ? '师傅' : '客服') +
      `将上门时间从 ${msg.getIn(['params', 'prevVal'])
        ? dayjs(msg.getIn(['params', 'prevVal'])).format('MM-DD HH:mm')
        : '"无"'
      } 改至 ${dayjs(msg.getIn(['params', 'currVal'])).format('MM-DD HH:mm')}`,
    assigned_to_worker: `已指派给 <span>${msg.getIn(['params', 'worker_name'])}</span>`,
    lock_fee_faild: `信用额度、余额不足，锁定工费单失败。请充值`,
    lock_fee_succeed: `订单金额已经锁定`,
    worker_feedback: `师傅有新的反馈`,
    add_accessory: `添加了有新的订单配件`,
    update_accessory: `订单配件状态有更新`,
    add_express: `添加了有新的订单快递`,
    worker_location_checked: '师傅已签到',
    worker_completed: '师傅已完单',
    express_changed: `<span>${msg.getIn(['params', 'username'])}</span>修改了快递信息`,
    tenant_confirm_completed: msg.getIn(['params', 'auto'])
      ? '企业确认超时，已自动结算'
      : '企业已确认完单',
    platform_confirm_completed:
      '客服已确认完单' +
      (tenantMode ? '(如果价格有误可对工单发起"申诉")' : ''),
    tag_changed: `${msg.getIn(['params', 'isAdd']) ? '设置' : '取消'}标签 “${getTag(msg.getIn(['params', 'tag'])).text
      }”`,
    worker_signin_timeout: `师傅超半小时未签到`,
    no_service_time: tenantMode
      ? null
      : `请尽快预约上门时间(第${msg.getIn(['params', 'count'])}次提醒)`,
    order_appeal: `<span>${msg.getIn(['params', 'username'])}</span>发起了订单申诉`,
    appeal_changed: `订单申诉审核${msg.getIn(['params', 'appeal_state']) == 2 ? '通过' : '未通过'}`,
    just_price: `客服<span>${msg.getIn(['params', 'username'])}</span>发起了调整${msg.getIn(['params', 'adjust_type']) == 2 ? '订单' : '师傅'}价格申请`,
    just_price_changed: `${msg.getIn(['params', 'adjust_type']) == 2 ? '订单' : '师傅'}调价审核${msg.getIn(['params', 'appeal_state']) == 2 ? '通过' : '未通过'}`,
    refuse_fee_succeed: `商家拒绝报价`,
    confirm_fee_succeed: `商家确认报价`,
    tag_changed: '设置标签',
    'reservice-assign': '再次上门-指派师傅',
    'reservice-pubone': '再次上门-发布一口价',
    'tenant-evaluate': '商家评价',
    'worker-applyfee': '师傅申请费用',
    'sub-evaluate-appeal': '师傅提交评价申诉',
    cancel_order: `客服 ”<span>${msg.getIn(['params', 'staff_no']) || msg.getIn(['params', 'username'])
      }</span>” 取消工单`,
    worker_cancel_order: `师傅 ”<span>${msg.getIn(['params', 'worker_name'])}</span>” 取消工单`,
  };

  const ignoreWithTenant = [
    'worker_feedback',
    'worker_completed',
    'worker_signin_timeout',
  ];

  if (tenantMode && ignoreWithTenant.includes(msg_text)) {
    return null;
  }

  if (msg_type === 'system_msg') {
    return systemMessages[msg_text] || null; // null 时不渲染
  } else if (msg_type === 'text') {
    return msg_text || '未知类型消息';
  } else {
    return '未知类型消息';
  }
}

export function compose(...funcs) {
  return (action) =>
    funcs.reduceRight((composed, func) => func(composed), action);
}

export function promisify(func) {
  return function (...args) {
    return new Promise((resolve, reject) => {
      func.call(func, ...args, function (err, result) {
        if (err) {
          return reject(err);
        }

        resolve(result);
      });
    });
  };
}

export function retryify2(fn, options = {}) {
  let retriesCount = 0;
  const maxRetries =
    typeof options === 'number' ? options : options.maxRetries || 3;

  options = {
    maxRetries: maxRetries,
    retryInterval:
      options.retryInterval || ((err, count) => Math.pow(2, count) * 1000),
    shouldRetry: options.shouldRetry || ((err, count) => true),
    beforeRetry: options.beforeRetry || ((err, count) => Promise.resolve()),
  };

  return function retry(...args) {
    const task = fn.apply(fn, args);

    if ({}.toString.call(task) !== '[object Promise]') {
      throw TypeError('missing promise');
    }

    task.catch((err) => {
      const maxRetriesReached = retriesCount++ >= options.maxRetries;

      if (maxRetriesReached || !options.shouldRetry(err, retriesCount)) {
        throw err;
      }

      const _runRetry = () =>
        Promise.resolve(options.beforeRetry(err, retriesCount))
          .then(() => {
            console.log(`[retry ${fn.name}] ${retriesCount}`);
          })
          .then(() => retry.apply(fn, args));

      if (typeof options.retryInterval === 'function') {
        const retryInterval = options.retryInterval(retriesCount);

        return new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve(_runRetry());
          }, retryInterval);
        });
      }

      return _runRetry();
    });

    return task;
  };
}

export function getFileMd5(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = (evt) => {
      if (evt.target.readyState == FileReader.DONE) {
        const hash = md5(evt.target.result);

        resolve(hash);
      }
    };
    reader.readAsBinaryString(file);
  });
}

export function calSize(width, height) {
  const rate = width / height;
  const isVertival = rate < 1;
  const minHeight = 60;
  const maxHeight = 180;
  const minWidth = 60;
  const maxWidth = isVertival ? 180 : 240;

  if (rate === 1) {
    return [180, 180, 180, 180];
  }

  if (isVertival) {
    // height > width, vertical image
    width = maxWidth;
    height = maxWidth / rate;
  } else {
    // height < width
    height = maxHeight;
    width = maxHeight * rate;
  }

  while (true) {
    if (isVertival) {
      if (height <= maxHeight || width <= minWidth) {
        return [width, height, width, Math.min(height, maxHeight)]; // final result
      } else {
        width -= 1;
        height = width / rate;
      }
    } else {
      if (width <= maxWidth || height <= minHeight) {
        return [width, height, Math.min(width, maxWidth), height]; // final result
      } else {
        height -= 1;
        width = height * rate;
      }
    }
  }
}
//快递公司代码
//顺丰、德邦、中通、圆通、申通、百世、韵达、京东、极兔
export const expressCompanyCode = {
  SF: '顺丰速运',
  DBKD: '德邦快递',
  ZTO: '中通快递',
  YTO: '圆通快递',
  STO: '申通快递',
  HTKY: '百世快递',
  YUNDA: '韵达快递',
  JT: '极兔快递',
  JD: '京东快递',
  POST: '中国邮政',
  ZTOKY: '中通快运',
  BESTQJT: '百世快运',
  POSTB: '邮政国内小包',
  EMS: 'EMS',
  FW: '丰网速运',
  KYE: '跨越速运',
  XFWL: '信丰快递',
  UC: '优速快递',
  TTKDEX: '天天快递',
  EYB: 'EMS快递包裹/邮政快递包裹',
  ZJS: '宅急送',
  ANE56: '安能',
  LB: '龙邦',
  FAST: '快捷',
  DBL: '德邦物流',
  DBKY: '德邦快运',
  ZTKY: '中铁物流/飞豹快递',
  CRE: '中铁快运',
  SURE: '速尔快递',
  UAPEX: '全一快递',
  CNEX: '佳吉快运',
  CP449455: '京广速运',
  JYM: '加运美速递',
  YDKY: '韵达快运',
  FEDEX: '联邦快递',
  POSTBK: '邮政标准快递',
  RRS: '日日顺',
  SNWL: '苏宁快递',
  ZMKM: '丹鸟',
  RFD: '如风达',
  YCKY: '远成快运',
  JYSCM: '九曳供应链',
  CP468398: '圆通承诺达',
  GTO: '国通',
  QFKD: '全峰',
  SDSD: '山东递速',
  CP443514: '百世云配',
  LE10032270: '韵达同城',
  PADTF: '平安达腾飞',
  YMDD: '壹米滴答',
  HOAU: '天地华宇',
  STOKY: '申通快运',
  CP471906: '顺心捷达',
  EWINSHINE: '万象物流',
  QRT: '全日通',
  GZFY: '凡宇快递',
  XBWL: '新邦物流',
  CAE: '民航快递',
  FEC: '银捷速递',
  SFWL: '盛丰物流',
  HLWL: '恒路物流',
  JIAYI: '佳怡物流',
  LTS: '联昊通',
  SZSA56: '圣安物流',
  SHENGHUI: '盛辉物流',
  YTZG: '运通中港快递',
  HMJ: '黄马甲配送',
  CHENGBANG: '晟邦物流',
  GZLT: '飞远配送',
  HZABC: '飞远(爱彼西)配送',
  JDYWL: '筋斗云物流',
  BJCS: '城市一百物流',
  YCT: '黑猫宅急便',
  ONTRAC: 'OnTrac',
  CITYLINK: 'City-Link',
  COE: 'COE',
  DTW: '大田物流',
  EES: '百福东方',
  MBEX: '民邦快递',
  HQKY: '华企快运',
  YFEXPRESS: '越丰物流',
  AIR: '亚风速递',
  MANCOWL: '万家物流',
  SZML56: '明亮物流',
  CXCOD: '传喜物流',
  D4PX: '递四方',
  TNT: 'TNT',
  UPS: 'UPS',
  USPS: 'USPS',
  DHLCN: 'DHL中国',
  EMSGJ: 'EMS国际',
  CNPOSTGJ: '邮政国际包裹',
  DHLDE: 'DHL德国',
  KERRYEAS: '嘉里大通',
  DHL: 'DHL全球',
  FEDEXUS: 'FedEx美国',
  FEDEXCN: 'FedEx中国',
  ARAMEX: 'Aramex',
  SANTAI: '三态速递',
  OCS: 'OCS',
  MYAAE: 'AAE全球专递',
  YWWL: '燕文物流',
  ASENDIA: 'Asendia USA',
  RUSTON: '俄速通',
  XLOBO: '贝海国际速递',
  SPSR: '中俄快递',
  SAD: '赛澳递',
  SUIJIAWL: '穗佳物流',
  ROYALMAIL: '英国皇家邮政',
  JKYZ: '捷克邮政',
  BLYZ: '波兰邮政',
  FGYZ: '法国邮政',
  POSTTR: '土耳其邮政',
  POSTCL: '智利邮政',
  POSTBY: '白俄罗斯邮政',
  POSTES: '西班牙邮政',
  POSTUA: '乌克兰邮政',
  POSTNO: '挪威邮政',
  POSTZA: '南非邮政',
  POSTPT: '葡萄牙邮政',
  POSTSA: '沙特邮政',
  POSTIN: '印度邮政',
  POSTBG: '保加利亚邮政',
  POSTAE: '阿联酋邮政',
  POSTAU: '澳大利亚邮政',
  POSTPK: '巴基斯坦邮政',
  POSTMT: '马耳他邮政',
  POSTLB: '黎巴嫩邮政',
  POSTMD: '摩尔多瓦邮政',
  POSTSRB: '塞尔维亚邮政',
  POSTHR: '克罗地亚邮政',
  POSTAM: '亚美尼亚邮政',
  POSTMK: '马其顿邮政',
  POSTFI: '芬兰邮政',
  POSTAR: '阿根廷邮政',
  POSTSK: '斯洛伐克邮政',
  SERPOST: '秘鲁邮政',
  POSTIT: '意大利邮政',
  POSTSI: '斯洛文尼亚邮政',
  POSTHU: '匈牙利邮政',
  POSTMU: '毛里求斯邮政',
  POSTAT: '奥地利邮政',
  POSTAL: '阿尔巴尼亚邮政',
  POSTEE: '爱沙尼亚邮政',
  POSTLV: '拉脱维亚邮政',
  POSTCO: '哥伦比亚邮政',
  POSTBR: '巴西邮政',
  POSTCH: '瑞士邮政',
  BLSYZ: '比利时邮政',
  RBYZEMS: '日本邮政',
  EPOST: '韩国邮政',
  POSTTH: '泰国邮政',
  POSTSE: '瑞典邮政'

}

// 快递查询返回的一级状态码
export const expressStatusMainCode = {
  WAIT_ACCEPT: '待揽收',
  ACCEPT: '已揽收',
  TRANSPORT: '运输中',
  DELIVERING: '派件中',
  AGENT_SIGN: '已代签收',
  SIGN: '已签收',
  FAILED: '包裹异常'
}

//1：（改价格）定价同意、2：修改通知、3：取消订单、4：申请配件已发件通知、5：工单挂起、6：修改预约时间、7：商家催师傅上门 8：师傅申请费用 9：师傅提交完单申请 
//10：师傅提交评价申诉 11：商家索赔 12商家催单 13修改价格 14商家拒绝报价 15客服确认结算 16师傅报价 17师傅签到 18师傅预约时间 19申诉调价 20指派师傅 
//21再次上门-指派师傅 22再次上门-发布一口价工单 23照片不规范 24核实未完成 25上门时间未达成一致  26索赔通过 27索赔不通过 30预约超时 31回复超时 32上门超时 50 聊天消息 99创建工单
export const tipType = {
  1: '同意定价',
  2: '修改通知',
  3: '取消订单',
  4: '申请配件已发件通知',
  5: '工单挂起',
  6: '修改预约时间',
  7: '商家催师傅上门',
  8: '师傅申请费用',
  9: '师傅提交完单申请',
  10: '师傅提交评价申诉',
  11: '商家索赔',
  12: '催单',
  13: '修改价格',
  14: '拒绝定价',
  15: '确认结算',
  16: '师傅报价',
  17: '师傅签到',
  18: '师傅预约时间',
  19: '申诉调价',
  20: '指派师傅',
  21: '再次上门-指派师傅',
  22: '再次上门-发布一口价',
  23: '照片不规范',
  24: '核实未完成',
  25: '上门时间未达成一致',
  26: '索赔通过',
  27: '索赔不通过',
  30: '预约超时',
  31: '回复超时',
  32: '上门超时',
  50: '发送消息',
  99: '创建订单',
}

export const priceToFixed = (price = 0, digit = 0) => {
  return (price && price.toFixed) ? Number(price.toFixed(digit)) : price;
};